import { ref } from 'vue'

const GIB = 1024 ** 3

/** Preserve an existing allowance until the administrator explicitly changes it. */
export function createStorageQuotaDraft() {
  const gb = ref(0)
  const configure = ref(true)
  const unlimited = ref(false)
  let initialGb = 0

  function open(bytes = 0, preservedUnlimited = false) {
    initialGb = Math.max(0, bytes) / GIB
    gb.value = initialGb
    unlimited.value = preservedUnlimited
    configure.value = !preservedUnlimited
  }

  function bytes() {
    const value = Number(gb.value)
    if (!Number.isFinite(value) || value < 0 || !Number.isSafeInteger(Math.round(value * GIB))) {
      throw new Error('存储额度须为不小于 0 的有效数字')
    }
    return Math.round(value * GIB)
  }

  function patch(): { storageQuotaBytes?: number } {
    if (!configure.value) return {}
    const quota = bytes()
    return unlimited.value || Number(gb.value) !== initialGb ? { storageQuotaBytes: quota } : {}
  }

  return { gb, configure, unlimited, open, bytes, patch }
}
